export default defineI18nConfig(() => ({}));
